import { insertImage$, usePublisher } from '@mdxeditor/editor';
import { Image as ImageIcon, Upload } from 'lucide-react';
import { FC, useRef, useState } from 'react';
import './image-toolbar-button.css';

// Кастомная кнопка вставки картинки вместо дефолтного диалога MDXEditor:
// только 2 варианта — загрузить файл или вставить по ссылке.
// insertImage$({ file }) — MDXEditor сам зальёт файл через imageUploadHandler
// из imagePlugin; insertImage$({ src }) — вставка по URL.
const ImageToolbarButton: FC = () => {
	const insertImage = usePublisher(insertImage$);
	const [open, setOpen] = useState(false);
	const [url, setUrl] = useState('');
	const fileRef = useRef<HTMLInputElement>(null);

	const close = () => {
		setOpen(false);
		setUrl('');
	};

	const onFile = (file?: File) => {
		if (!file) return;
		insertImage({ file, altText: '' });
		close();
	};

	const onUrl = () => {
		const src = url.trim();
		if (!src) return;
		insertImage({ src, altText: '' });
		close();
	};

	return (
		<>
			<button
				type='button'
				className='image-toolbar-btn'
				title='Вставить изображение'
				onClick={() => setOpen(true)}
			>
				<ImageIcon size={18} />
			</button>

			{open && (
				<>
					<div
						className='modal-backdrop fade show'
						style={{ zIndex: 1074 }}
						onClick={close}
					/>
					<div
						className='modal fade show d-block'
						style={{ zIndex: 1075 }}
						onClick={close}
					>
						<div
							className='modal-dialog modal-dialog-centered modal-sm'
							onClick={e => e.stopPropagation()}
						>
							<div className='modal-content'>
								<div className='modal-header py-4'>
									<h5 className='modal-title fs-5'>Вставить изображение</h5>
									<button
										type='button'
										className='btn btn-icon btn-sm btn-active-light-primary'
										onClick={close}
										aria-label='Закрыть'
									>
										<span className='fs-2'>&times;</span>
									</button>
								</div>
								<div className='modal-body'>
									<button
										type='button'
										className='btn btn-light-primary w-100 d-flex align-items-center justify-content-center gap-2 py-3'
										onClick={() => fileRef.current?.click()}
									>
										<Upload size={18} /> Загрузить файл
									</button>
									<input
										ref={fileRef}
										type='file'
										accept='image/*'
										className='d-none'
										onChange={e => onFile(e.target.files?.[0])}
									/>

									<div className='d-flex align-items-center my-4 text-muted'>
										<div className='flex-grow-1 border-bottom' />
										<span className='px-3 fs-8 text-uppercase'>или</span>
										<div className='flex-grow-1 border-bottom' />
									</div>

									<label className='form-label fw-semibold fs-7'>
										Ссылка на изображение
									</label>
									<div className='input-group'>
										<input
											type='url'
											className='form-control form-control-solid'
											placeholder='https://...'
											value={url}
											onChange={e => setUrl(e.target.value)}
											onKeyDown={e => {
												if (e.key === 'Enter') {
													e.preventDefault();
													onUrl();
												}
											}}
										/>
										<button
											type='button'
											className='btn btn-primary'
											onClick={onUrl}
											disabled={!url.trim()}
										>
											Вставить
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export { ImageToolbarButton };
